import { render, staticRenderFns } from "./EditSystemArticle.vue?vue&type=template&id=95f127c2&scoped=true&"
import script from "./EditSystemArticle.vue?vue&type=script&lang=js&"
export * from "./EditSystemArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditSystemArticle.vue?vue&type=style&index=0&id=95f127c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f127c2",
  null
  
)

export default component.exports